import React from 'react';
import {
    ArrayField,
    BooleanInput,
    BooleanField,
    Datagrid,
    Edit,
    FormTab,
    List,
    ReferenceField,
    ShowButton,
    Tab,
    TabbedForm,
    TabbedShowLayout,
    TextField,
    SelectInput,
    ShowController,
    ShowView,
    TextInput } from 'react-admin';
import { Filter } from 'react-admin';
import { SparklineField } from '../SparklineField';
import { EChartField } from '../EChartField'
import Icon from '@material-ui/icons/AttachMoney';
import withStyles from "@material-ui/core/styles/withStyles";

export const AtomicIcon = Icon;

const AtomicFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <SelectInput
            source="status"
            choices={[
                { id: 'RUNNING', name: 'RUNNING' },
                { id: 'SUCCEEDED', name: 'SUCCEEDED' },
                { id: 'ABORTED', name: 'ABORTED' },
                { id: 'FAILED', name: 'FAILED' },
                { id: 'TIMED_OUT', name: 'TIMED_OUT' },
            ]}
        />
    </Filter>

);

const listStyles = {
    name: { padding: '0 12px 0 25px' },
};

export const AtomicList = withStyles(listStyles)(({ classes, ...props }) => (
    <List title={<AtomicTitle />}  {...props} filters={<AtomicFilter />} sort={{ field: 'startDate', order: 'DESC' }} >
        <Datagrid>
            <TextField source="id" sortable={false} />
            <TextField source="AtomicStatus" sortable={false} />
            <BooleanField label="Data Valid" source="data_valid" />
            <TextField source="Created"  />
            <ShowButton />
        </Datagrid>
    </List>
));


const AtomicTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>Atomic test {record ? `"${record.id}"` : ''}</span>;
};


export const AtomicShow = props => (
    <ShowController title={<AtomicTitle />} {...props}>
        {controllerProps =>
            <ShowView {...props} {...controllerProps}>
                <TabbedShowLayout>
                    <Tab label = "Summary">
                        <TextField  source="id" />
                        <TextField  source="AtomicStatus" />
                        <TextField  source="startDate" />
                        <ReferenceField label="Build" source="BuildId" reference="build">
                            <TextField source="Description.build" />
                        </ReferenceField>
                        <ReferenceField label="Run" source="RunId" reference="run">
                            <TextField source="GroupDescription" />
                        </ReferenceField>
                        <ReferenceField label="Sweep" source="SweepId" reference="sweep">
                            <TextField source="ConfigId" />
                        </ReferenceField>
                    </Tab>
                    <Tab label = "Load">
                        <BooleanField label="Data Valid" source="AtomicLoad.data_valid" />
                        <TextField  label="Cpu average" source="AtomicLoad.Cpu" />
                        <SparklineField label="Cpu history" source="AtomicLoad.cpu_list" />
                        <TextField  label="Throttle" source="AtomicLoad.Throttle" />
                    </Tab>
                    <Tab label = "Alarms">
                        <TextField  label="Open Alarms" source="AtomicLoad.AlarmDict" />
                    </Tab>
                    <Tab label = "Raised Alarms">
                        <TextField  label="Raised Alarms" source="AtomicLoad.RaisedAlarmDict" />
                    </Tab>
                    <Tab label = "Load Charts">
                        <EChartField  source="CpuChart"/>
                        <EChartField  source="ThrottleChart"/>
                    </Tab>
                    <Tab label = "SVQ Charts">
                        <ArrayField source="SvqCharts">
                            <Datagrid>
                                <EChartField label="--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------" source="chart" />
                            </Datagrid>
                        </ArrayField>
                    </Tab>
                    <Tab label = "Throttle Charts">
                        <ArrayField source="ThrottleCharts">
                            <Datagrid>
                                <EChartField label="--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------" source="chart" />
                            </Datagrid>
                        </ArrayField>
                    </Tab>
                </TabbedShowLayout>
            </ShowView>
        }
    </ShowController>
);


export const AtomicEdit = props => (
    <Edit title={<AtomicTitle />} {...props}>
        <TabbedForm>
            <FormTab label="Summary">
                <TextInput source="BuildDescription" />
            </FormTab>
            <FormTab label="Action">
                <BooleanInput label="Repeat test" source="Repeat" />
            </FormTab>
        </TabbedForm>
    </Edit>
);
